import { ConfirmDialog } from "../../ui";

type DeleteSeasonDialogProps = {
  seasonName: string;
  tournamentCount: number;
  isOpen: boolean;
  onDelete: () => Promise<void>;
  onClose: (update?: boolean) => void;
};

const DeleteSeasonDialog = (props: DeleteSeasonDialogProps) => (
  <ConfirmDialog
    open={props.isOpen}
    // Error is handled by the parent component; a failed delete keeps the dialog open
    onConfirm={props.onDelete}
    onClose={(confirmed) => props.onClose(confirmed ? true : undefined)}
    title="Delete Season"
    heading="Are you sure?"
    confirmLabel="Delete"
    confirmDisabled={props.tournamentCount > 0}
    message={
      props.tournamentCount > 0 ? (
        <>
          This season cannot be deleted because it has <strong>{props.tournamentCount}</strong> associated
          tournament{props.tournamentCount > 1 ? "s" : ""}. Please remove all tournaments from this season
          before deleting it.
        </>
      ) : (
        <>
          This action cannot be undone. If you delete <strong>{props.seasonName}</strong>, it will be
          permanently removed.
        </>
      )
    }
  />
);

export default DeleteSeasonDialog;
